
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import {Route} from "vue-router";
import {Prop} from "vue-property-decorator";
import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import { settings } from '@/main';
import { cultureService } from '@/CultureService';
import {
    SysAdminCertificateTypeTemplatesClient,
    CertificateTypeTemplateDetailsModel
} from "@/api-client";

@Component({
    components: {
        SectionPageHeading,
        HeadingWave,
        AdministrationDetailviewLayout,
        HeadingGroup
    },
    methods: {
        translateTrueFalse
    }
})
export default class CertificateTypeTemplate extends Vue {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        try {
            const client = new SysAdminCertificateTypeTemplatesClient();
            const template = await client.get(to.params.id);
            to.meta!.props.preloadedTemplate = template;
            next();
        } catch (error) {
            console.error('Error loading certificate type template:', error);
            next(error);
        }
    }

    @Prop({required: true})
    preloadedTemplate!: CertificateTypeTemplateDetailsModel;

    model = this.preloadedTemplate;

    get localizedDescription(): string {
        if (!this.model.description) return "-";

        const description = this.model.description;
        return cultureService.currentCulture === 'et-EE'
            ? (description.et || description.en || "-")
            : (description.en || description.et || "-");
    }

    getProcessedDownloadUrl(): string {
        // Use the public download endpoint that replaces placeholders with values
        // Add timestamp to avoid cache
        return `${settings.misApiBaseUrl}/api/certificate-type-templates/${this.model.id}/download?t=${Date.now()}`;
    }

    downloadTemplate() {
        // Use iframe to trigger download without navigation
        const url = this.getProcessedDownloadUrl();
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);

        // Remove iframe after download starts
        setTimeout(() => {
            document.body.removeChild(iframe);
        }, 5000);
    }
}
